import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
export const GET_INTERNAL_AUDIT_CASE_LIST = 'GET_INTERNAL_AUDIT_CASE_LIST';

export const service = async (data) => {
    const options: object = {
      url: `/api/EaCaseApiController/GetInternalAuditCaseList?eaAuditId=` + data,
      method: "GET",
    };
    const response = callMvcApi(options);
    return response;
  };

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_INTERNAL_AUDIT_CASE_LIST, service, mock);
